import { render, staticRenderFns } from "./teachingResearchIntelligentBodyDialogue.vue?vue&type=template&id=75d01114&scoped=true"
import script from "./teachingResearchIntelligentBodyDialogue.vue?vue&type=script&lang=js"
export * from "./teachingResearchIntelligentBodyDialogue.vue?vue&type=script&lang=js"
import style0 from "./teachingResearchIntelligentBodyDialogue.vue?vue&type=style&index=0&id=75d01114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d01114",
  null
  
)

export default component.exports